/* Maximal Museum — shared chrome + cart (persisted across pages via localStorage) */
(function(){
  "use strict";

  /* Where the two pages live. Plain files when the site is hosted as static
     HTML; Shopify rewrites these to its own routes via window.MM_ROUTES, which
     the theme layout sets before this script runs. */
  var ROUTES = { home:'index.html', product:'product.html' };
  if (window.MM_ROUTES){
    if (window.MM_ROUTES.home) ROUTES.home = window.MM_ROUTES.home;
    if (window.MM_ROUTES.product) ROUTES.product = window.MM_ROUTES.product;
  }

  /* rzpPlan is what actually bills the customer, and `charge` is the amount
     the Razorpay plan behind that membership's button is configured for.
     The site may never print a price it will not charge, so `charge` has the
     last word: applyCatalogue() below will rewrite the words around a plan
     from Shopify, but refuses a price that disagrees with it. If a price
     changes in the Razorpay dashboard, change `charge` and `price` here in
     the same sitting.

     Checked against Razorpay on 7 Aug 2026:
       quarterly  button pl_TMy0CXqvYy405w → plan_TKum0j9zVpajL3
                  "Bulletin — Quarterly", monthly × 3, ₹1,197
       annual     button pl_TMy3aBfEIuHzOZ → plan_TKun4FE5ud5ak5
                  "Bulletin — Annual", yearly × 1, ₹4,068 */
  var PLANS = [
    { id:'quarterly', name:'Quarterly', price:1197, charge:1197, rzpPlan:'ppi_TMy0CemY7LkqoK',
      note:'Three issues, three postcards. Renews every quarter.' },
    { id:'annual', name:'Annual', price:4068, charge:4068, rzpPlan:'ppi_TMy3aIJmGpZ3sz',
      note:'15% off, plus the exclusive 13th Bulletin in your birthday month.' }
  ];

  var PROPS = {
    issueLine: 'Membership · One letter a month',
    deadlineLine: 'Subscribe now to start with the September 2026 issue — open until August 25th.',
    /* read through to the plans so the two can never drift apart */
    get priceQuarterly(){ return findPlan('quarterly').price; },
    get priceAnnual(){ return findPlan('annual').price; }
  };

  /* a copy each time: display code must not be able to edit the catalogue,
     and `charge` stays in here where only applyCatalogue() consults it */
  function planList(){
    var out = [];
    for (var i=0;i<PLANS.length;i++){
      var p = PLANS[i];
      out.push({ id:p.id, name:p.name, price:p.price, rzpPlan:p.rzpPlan, note:p.note });
    }
    return out;
  }
  function findPlan(id){ var l = planList(); for (var i=0;i<l.length;i++){ if (l[i].id===id) return l[i]; } return l[0]; }

  /* ── catalogue feed ────────────────────────────────────────────────
     Shopify owns the words around a membership. It does NOT own the
     amount: Razorpay bills by rzpPlan, so a catalogue price that
     disagrees with `charge` would put a number on screen that is not the
     number taken from the card. Those are refused and reported instead. */
  var catalogueHooks = [];
  function onCatalogue(fn){ if (typeof fn === 'function') catalogueHooks.push(fn); }

  function applyCatalogue(patch){
    var applied = [], refused = [];
    if (patch){
      for (var i=0;i<PLANS.length;i++){
        var p = PLANS[i], next = patch[p.id];
        if (!next) continue;
        if (typeof next.name === 'string' && next.name) p.name = next.name;
        if (typeof next.note === 'string' && next.note) p.note = next.note;
        if (next.price !== null && next.price !== undefined){
          var offered = Number(next.price);
          if (offered === p.charge){
            p.price = offered;
            applied.push(p.id);
          } else {
            refused.push({ id:p.id, offered:offered, charging:p.charge });
            if (window.console && console.error){
              console.error('[MM] catalogue lists ' + p.id + ' at ' + offered
                + ' but Razorpay plan ' + p.rzpPlan + ' bills ' + p.charge
                + '. Showing ' + p.charge + '. Reconcile the two before either goes live.');
            }
          }
        }
      }
    }
    refresh();
    for (var h=0;h<catalogueHooks.length;h++){ try { catalogueHooks[h](); } catch(e){} }
    return { applied:applied, refused:refused };
  }
  /* money() is plain text — fine for a title or an aria-label. Anything the
     customer actually reads on screen must use moneyHTML(), because the ₹
     has to be wrapped in .rupee to escape Futura PT's ruble glyph. */
  function money(n){ return '₹' + Number(n).toLocaleString('en-IN'); }
  function moneyHTML(n){ return '<span class="rupee">₹</span>' + Number(n).toLocaleString('en-IN'); }
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  var KEY = 'mm_cart';
  function loadCart(){ try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch(e){ return []; } }
  function saveCart(){ try { localStorage.setItem(KEY, JSON.stringify(cart)); } catch(e){} }
  var cart = loadCart();
  var cartOpen = false, menuOpen = false;

  /* asHtml is only ever passed our own generated markup (moneyHTML) */
  function setBind(name, val, asHtml){
    var els = document.querySelectorAll('[data-bind="'+name+'"]');
    for (var i=0;i<els.length;i++){
      if (asHtml) els[i].innerHTML = val; else els[i].textContent = val;
    }
  }

  function cartRow(l, p){
    return '<div style="padding:24px 0; border-bottom:1px solid rgba(244,239,231,0.16)">'
      + '<div style="display:flex; justify-content:space-between; gap:14px; font-size:10px; letter-spacing:.24em; text-transform:uppercase; color:#C8A96E"><span>'+esc(p.name)+' membership</span><span class="money">'+moneyHTML(p.price*l.qty)+'</span></div>'
      + '<div style="margin-top:10px; font-family:var(--sea); font-size:23px; font-weight:300">The Bulletin</div>'
      + '<div style="margin-top:6px; font-size:12px; color:rgba(244,239,231,0.6)">'+esc(p.note)+'</div>'
      + '<div style="margin-top:16px; display:flex; align-items:center; gap:14px">'
      +   '<button data-a="cdec" data-id="'+l.id+'" style="width:44px; height:44px; background:none; border:1px solid rgba(244,239,231,0.3); cursor:pointer; color:#F4EFE7">−</button>'
      +   '<span style="font-size:13px; min-width:14px; text-align:center">'+l.qty+'</span>'
      +   '<button data-a="cinc" data-id="'+l.id+'" style="width:44px; height:44px; background:none; border:1px solid rgba(244,239,231,0.3); cursor:pointer; color:#F4EFE7">+</button>'
      +   '<button data-a="crem" data-id="'+l.id+'" class="h-rem" style="margin-left:auto; background:none; border:none; cursor:pointer; font-size:10px; text-transform:uppercase; letter-spacing:.2em; color:rgba(244,239,231,0.5)">Remove</button>'
      + '</div>'
      + '</div>';
  }

  function refresh(){
    var count = 0, total = 0;
    for (var i=0;i<cart.length;i++){ var p = findPlan(cart[i].id); count += cart[i].qty; total += p.price*cart[i].qty; }
    setBind('cartCount', String(count));
    setBind('subtotal', moneyHTML(total), true);

    var itemsCont = document.querySelector('[data-cart-items]');
    var empty = document.querySelector('[data-cart-empty]');
    if (empty) empty.style.display = cart.length===0 ? 'block' : 'none';
    if (itemsCont){
      var html = '';
      for (var j=0;j<cart.length;j++){ html += cartRow(cart[j], findPlan(cart[j].id)); }
      itemsCont.innerHTML = html;
    }
    var cartEl = document.getElementById('cart'); if (cartEl) cartEl.style.display = cartOpen ? 'block' : 'none';
    var menuEl = document.getElementById('menu'); if (menuEl) menuEl.style.display = menuOpen ? 'flex' : 'none';

    /* the page underneath must not scroll away while an overlay is open —
       on phones that is the difference between a drawer and a mess */
    if (document.body){
      if (cartOpen || menuOpen) document.body.classList.add('mm-lock');
      else document.body.classList.remove('mm-lock');
    }
  }

  function openCart(){ cartOpen = true; menuOpen = false; refresh(); }
  function toggleCart(){ cartOpen = !cartOpen; menuOpen = false; refresh(); }
  function toggleMenu(){ menuOpen = !menuOpen; cartOpen = false; refresh(); }
  function buy(id, qty){
    var hit = null;
    for (var i=0;i<cart.length;i++){ if (cart[i].id===id) hit = cart[i]; }
    if (hit) hit.qty += qty; else cart.push({ id:id, qty:qty });
    saveCart(); openCart();
  }
  /* replace the whole bag in one go — checkout uses this to keep the bag
     showing exactly the membership being bought. Goes through here rather
     than writing localStorage directly so `cart` above never goes stale. */
  function setCart(list){
    cart = Array.isArray(list) ? list.slice() : [];
    saveCart(); refresh();
  }
  /* a copy, so a reader cannot mutate the bag behind setCart()'s back */
  function getCart(){
    var out = [];
    for (var i=0;i<cart.length;i++) out.push({ id:cart[i].id, qty:cart[i].qty });
    return out;
  }
  function cinc(id){ for (var i=0;i<cart.length;i++){ if(cart[i].id===id) cart[i].qty += 1; } saveCart(); refresh(); }
  function cdec(id){ var out=[]; for (var i=0;i<cart.length;i++){ var x=cart[i]; if(x.id===id) x.qty-=1; if(x.qty>0) out.push(x); } cart=out; saveCart(); refresh(); }
  function crem(id){ var keep=[]; for (var i=0;i<cart.length;i++){ if(cart[i].id!==id) keep.push(cart[i]); } cart=keep; saveCart(); refresh(); }

  function scrollToSel(sel){
    menuOpen = false; cartOpen = false; refresh();
    var els = document.querySelectorAll(sel), el = null;
    for (var i=0;i<els.length;i++){ if (els[i].getClientRects().length){ el = els[i]; break; } }
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 96;
    window.scrollTo({ top: Math.max(0, top), behavior:'smooth' });
  }
  function anchor(name){
    if (document.querySelector('[data-'+name+']')) scrollToSel('[data-'+name+']');
    else location.href = ROUTES.home + '#' + name;
  }

  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('[data-a]') : null;
    if (!a) return;
    var act = a.getAttribute('data-a');
    var chrome = { toggleMenu:1, toggleCart:1, goTop:1, goHome:1, goProduct:1, goProductQuarterly:1, goProductAnnual:1, goTestimonials:1, goFaq:1, cinc:1, cdec:1, crem:1 };
    if (!chrome[act]) return;
    if (a.tagName === 'A') e.preventDefault();
    switch(act){
      case 'toggleMenu': toggleMenu(); break;
      case 'toggleCart': toggleCart(); break;
      case 'goTop':
        menuOpen = false; cartOpen = false; refresh();
        if (document.querySelector('[data-home]')) window.scrollTo({ top:0, behavior:'smooth' });
        else location.href = ROUTES.home;
        break;
      case 'goHome': location.href = ROUTES.home; break;
      case 'goProduct': location.href = ROUTES.product; break;
      case 'goProductQuarterly': location.href = ROUTES.product + '?plan=quarterly'; break;
      case 'goProductAnnual': location.href = ROUTES.product + '?plan=annual'; break;
      case 'goTestimonials': anchor('testimonials'); break;
      case 'goFaq': anchor('faq'); break;
      case 'cinc': cinc(a.getAttribute('data-id')); break;
      case 'cdec': cdec(a.getAttribute('data-id')); break;
      case 'crem': crem(a.getAttribute('data-id')); break;
    }
  });

  window.MM = {
    PROPS: PROPS, planList: planList, findPlan: findPlan, money: money, moneyHTML: moneyHTML, esc: esc,
    setBind: setBind, refresh: refresh, buy: buy, setCart: setCart, getCart: getCart, openCart: openCart,
    applyCatalogue: applyCatalogue, onCatalogue: onCatalogue
  };

  document.addEventListener('DOMContentLoaded', function(){
    refresh();
    if (location.hash){
      var t = location.hash.slice(1);
      setTimeout(function(){
        var el = document.querySelector('[data-'+t+']');
        if (el){ var top = el.getBoundingClientRect().top + window.pageYOffset - 96; window.scrollTo({ top: Math.max(0, top) }); }
      }, 60);
    }
  });
})();
